<ts-dialog [title]="title" (closeDialog)="discard()">
  <div ts-dialog-body>
    @if (portfolios$ | async; as portfolios) {
      @if ((ui | async).merging) {
        <div class="merging-panel">
          <mat-spinner></mat-spinner>
          <div class="merging-panel__progress">
            @for (message of progressMessages | async; track message) {
              <p class="animate__animated animate__slideInDown animate__faster">
                @if (message === 'An error occurred') {
                  <ts-icon icon="ts_close" class="red-error"></ts-icon> {{ message }}
                } @else if (message === 'Complete') {
                  <ts-icon icon="check_circle" class="green-success"></ts-icon> {{ message }}
                } @else {
                  <ts-icon icon="merge_type"></ts-icon> {{ message }}
                }
              </p>
            }
          </div>
        </div>
      } @else if ((ui | async).failed) {
        <div class="failed-panel">
          <div class="failed-panel__header">
            <ts-icon icon="warning" class="warning-icon"></ts-icon>
            <h3>Portfolio Separation Results</h3>
          </div>
          
          @if (successfulItems.length > 0) {
            <div class="successful-items">
              <h4>Successfully Separated ({{ successfulItems.length }})</h4>
              @for (item of successfulItems; track item.project_id) {
                <p class="successful-item">
                  <ts-icon icon="check_circle" class="green-success"></ts-icon> {{ item.title }}
                </p>
              }
            </div>
          }
          
          @if (failedItems.length > 0) {
            <div class="failed-items">
              <h4>Failed to Separate ({{ failedItems.length }})</h4>
              @for (item of failedItems; track item.project_id) {
                <p class="failed-item">
                  <ts-icon icon="ts_close" class="red-error"></ts-icon> 
                  <span class="item-title">{{ item.title }}</span>
                  @if (item.message) {
                    <span class="error-message">- {{ item.message }}</span>
                  }
                </p>
              }
            </div>
          }
        </div>
      } @else {
        <form class="flex flex-col justify-center gap-2" [formGroup]="form">
          @if (mode === 'existing') {
            <span class="flex flex-row items-center justify-between">
              <p>Portfolio</p>
              <ts-select
                itemKey="id"
                itemLabel="title"
                formControlName="destination_portfolio_id"
                class="w-1/2"
                [uiOptions]="{
                  roundedBorders: false,
                  placeholder: 'Select a portfolio',
                  searchPlaceholder: 'Portfolio...',
                  size: 'full',
                }"
                [items]="portfolios"
              ></ts-select>
            </span>
          }
          @if (mode === 'new') {
            <span class="flex flex-row items-center justify-between">
              <p>Portfolio Name</p>
              <ts-input
                placeholder="Portfolio Name"
                class="w-1/2"
                [roundedBorders]="false"
                formControlName="destination_portfolio_name"
              ></ts-input>
            </span>

            <span class="flex flex-row items-center justify-between">
              <p>View</p>
              <ts-select
                itemKey="id"
                itemLabel="name"
                formControlName="destination_portfolio_pipeline_id"
                class="w-1/2"
                [uiOptions]="{
                  roundedBorders: false,
                  placeholder: 'Select a view',
                  searchPlaceholder: 'View...',
                  size: 'full',
                }"
                [items]="dialogData.pipelines"
              ></ts-select>
            </span>

            <span class="flex flex-row items-center justify-between">
              <p>Layout</p>
              <ts-select
                itemKey="id"
                itemLabel="name"
                formControlName="destination_portfolio_layout_id"
                class="w-1/2"
                [uiOptions]="{
                  roundedBorders: false,
                  placeholder: 'Select a layout',
                  searchPlaceholder: 'Layout...',
                  size: 'full',
                }"
                [items]="dialogData.templates"
              ></ts-select>
            </span>
          }

          @if (mode === 'split') {
            <div class="new-structure-preview">
              <p class="new-structure-preview__parent">
                Each will become a standalone deal
              </p>
              <p></p>
              @for (project of previewDataSplit?.preview?.projects || []; track project) {
                <p class="new-structure-preview__child">
                  <mat-icon svgIcon="subdirectory_arrow_right"></mat-icon> {{ project.title }}
                </p>
              }
            </div>
          }

          @if ((ui | async).preview && mode !== 'split') {
            <div class="new-structure-preview">
              <p class="new-structure-preview__parent">
                These deals from your selection will be added to the portfolio
              </p>
              <p></p>
              @for (child of previewDataMerge.children; track child) {
                <p class="new-structure-preview__child">
                  <mat-icon svgIcon="subdirectory_arrow_right"></mat-icon> {{ child }}
                </p>
              }
            </div>
          }
        </form>
      }
    } @else {
      <div class="flex flex-col w-full gap-2">
        <ts-skeleton />
        <ts-skeleton />
        <ts-skeleton />
        <ts-skeleton />
      </div>
    }
  </div>

  <div class="ts-dialog-actions-container" ts-dialog-actions>
    <ts-button type="flat" color="basic" (click)="discard()">Cancel</ts-button>
    @if ((ui | async).failed) {
      <ts-button 
        type="flat" 
        color="primary" 
        [loading]="(ui | async).loading"
        [disabled]="failedItems.length === 0"
        (click)="retryFailedItems()"
      >
        Try Again ({{ failedItems.length }})
      </ts-button>
    } @else if ((ui | async).preview) {
      <ts-button [loading]="(ui | async).loading" type="flat" (click)="handleAction(true)">
        @if (mode === 'new') {
          Create
        }
        @if (mode === 'existing') {
          Add
        }
        @if (mode === 'split') {
          Confirm
        }
      </ts-button>
    } @else {
      <ts-button [loading]="(ui | async).loading" [disabled]="mode === 'split' || !form.valid" type="flat" (click)="handleAction()"
        >Validate</ts-button
      >
    }
  </div>
</ts-dialog>
